import { produce } from 'immer'
// @ts-ignore
import { str } from './utils'
import paymentActions from '../actions/payment'
import authActions from '../actions/auth'

interface PaymentState {
  list: any[]
  loading: boolean
}

const initialState: PaymentState = {
  list: [],
  loading: false,
}

const reducer = (draft: PaymentState, { type, payload }: any) => {
  switch (type) {
    case str(paymentActions.fetchList.request):
      draft.loading = true
      return
    case str(paymentActions.fetchList.success):
      draft.list = payload.data || []
      draft.loading = false
      return
    case str(paymentActions.fetchList.failure):
      draft.loading = false
      return
    case str(paymentActions.createCard.request):
    case str(paymentActions.updateDefault.request):
    case str(paymentActions.deleteMethod.request):
      draft.loading = true
      return
    case str(paymentActions.createCard.success):
    case str(paymentActions.updateDefault.success):
    case str(paymentActions.deleteMethod.success):
      // After mutation, list is refreshed via saga re-fetch
      draft.list = payload.data || draft.list
      draft.loading = false
      return
    case str(paymentActions.createCard.failure):
    case str(paymentActions.updateDefault.failure):
    case str(paymentActions.deleteMethod.failure):
      draft.loading = false
      return
    case str(authActions.logout.success):
      return initialState
  }
}

export default (state = initialState, action: any) =>
  produce(state, (draft: PaymentState) => reducer(draft, action))
